import config from '@constants/config';
import { decryptObject } from '@shared/utils';
import { extendSessionService, signInService } from '@shared/services/api/authService';
import { getUserProfile } from '@shared/services/api/correspondentUsersServices';
import { signInFail, signInStart, signInSuccess, signOutSuccess, updateUser } from '../../reducers/auth/authReducer';
const { ENABLE_COOKIES } = config;

export const signIn = (tenant, data) => async (dispatch) => {
  try {
    dispatch(signInStart());
    const response = await signInService(tenant, data);
    if (response.data.errors.length > 0) {
      dispatch(signInFail(response.data.errors[0].message));
      return;
    }

    const loggedUser = response.data.data;
    const decryptedLoggedUser = decryptObject(loggedUser);
    if (!ENABLE_COOKIES) {
      localStorage.setItem('TOKEN', decryptedLoggedUser.token);
    }
    localStorage.setItem('USER', loggedUser);
    if (decryptedLoggedUser.tenants) {
      localStorage.setItem('tenant', loggedUser);
    }

    dispatch(signInSuccess(decryptObject(loggedUser)));
  } catch (error) {
    console.error(error);
    dispatch(signInFail("Error al iniciar sesión, Contacte al administrador"));
  }
};

export const extendSession = () => async (dispatch) => {
  try {
    const response = await extendSessionService();
    if (response) {
      localStorage.setItem('TOKEN', response.data.accessToken);
    }
  } catch (error) {
    dispatch(signInFail(error.data.errors[0].message));
  }
};

export const signOut = () => (dispatch) => {
  localStorage.clear();
  sessionStorage.clear();
  const expired = 'expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  document.cookie = `session_e=; ${expired}`;
  document.cookie = `session_status=; ${expired}`;
  dispatch(signOutSuccess());
};

export const updateUserProfile =
  (username, tenantId = null) =>
  async (dispatch) => {
    try {
      const response = await getUserProfile(username, tenantId);
      dispatch(updateUser({ subsidiary: response.subsidiary_id, ...response }));
    } catch (error) {
      dispatch(signInFail(error.data.errors[0].message));
    }
  };
